import { ChangeDetectionStrategy, Component, computed, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Store } from '@softline/core';
import { Router } from '@angular/router';
import {
  BackNavigationService,
  BlockingLoadingSpinnerComponent,
  showRequestErrors,
  HeaderComponent,
  SOFTLINE_FEATURE_TITLE,
  Step,
  StepHeaderComponent,
  TitleStore,
} from '@softline/application';
import { ModalStore, SOFTLINE_FEATURE_MODAL, UiCoreModule } from '@softline/ui-core';
import { SOFTLINE_FEATURE_INVENTUR } from '../../inventur.shared';
import { InventurStore } from '../../store';
import {
  ArtikelMenge,
  ArtikelMengeAuswahlComponent,
  Lagerplatz,
  LagerplatzInhalt,
  LagerplatzSucheStore,
  SOFTLINE_FEATURE_LAGERPLATZ_SUCHE,
} from '@softapps/lager/core';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'soft-artikel-auswahl',
  imports: [
    CommonModule,
    UiCoreModule,
    StepHeaderComponent,
    ArtikelMengeAuswahlComponent,
    BlockingLoadingSpinnerComponent,
    HeaderComponent,
  ],
  templateUrl: './artikel-auswahl.page.html',
  styleUrls: ['./artikel-auswahl.page.css'],
})
export class ArtikelAuswahlPage implements OnInit {
  readonly steps: Step[] = [
    {
      header: '#INVENTUR.PAGES.LAGERPLATZ_SCANNEN.TITLE',
      subHeader: '#INVENTUR.PAGES.LAGERPLATZ_SCANNEN.DESCRIPTION',
    },
    {
      header: '#INVENTUR.PAGES.ARTIKEL_AUSWAHL.TITLE',
      subHeader: '#INVENTUR.PAGES.ARTIKEL_AUSWAHL.DESCRIPTION',
    },
    {
      header: '#INVENTUR.PAGES.MENGEN_AUSWAHL.TITLE',
      subHeader: '#INVENTUR.PAGES.MENGEN_AUSWAHL.DESCRIPTION',
    },
  ];

  loading$ = new BehaviorSubject<boolean>(false);
  lagerplatz = this.store.signal(
    SOFTLINE_FEATURE_INVENTUR,
    InventurStore.getters.lagerplatz
  );

  readonly inhalt = computed(() => {
    const inhalt = this.lagerplatz()?.inhalt;

    return inhalt?.filter(inhalt => !inhalt?.menge_inv || inhalt?.menge_inv === 0 ) ?? [];
  })

  readonly inhaltInv = computed(() => {
    const inhalt = this.lagerplatz()?.inhalt;

    console.log('inhaltInv', inhalt);

    return inhalt?.filter(inhalt => (inhalt?.menge_inv ?? 0) > 0 ) ?? [];
  })

  constructor(
    private store: Store,
    private router: Router,
    private backNavigationService: BackNavigationService
  ) {}

  ngOnInit(): void {
    this.backNavigationService.set(this);
    this.store.commit(
      SOFTLINE_FEATURE_TITLE,
      TitleStore.mutations.setTitle,
      '#INVENTUR.TITLE'
    );
  }

  ngOnDestroy() {
    this.store.commit(SOFTLINE_FEATURE_TITLE, TitleStore.mutations.setTitle, '');
    this.backNavigationService.set(undefined);
  }

  async navigateBack(): Promise<void> {
    const lagerplaetze = this.store.get(
      SOFTLINE_FEATURE_LAGERPLATZ_SUCHE,
      LagerplatzSucheStore.getters.data
    );

    if (!lagerplaetze) {
      await this.router.navigate(['/inventur']);
      return;
    }

    const result = await this.store.dispatch(
      SOFTLINE_FEATURE_MODAL,
      ModalStore.actions.choose<Lagerplatz>(),
      {
        title: '#LAGERPLATZ_CORE.DIALOGS.CHOOSE_LAGERPLATZ',
        options: lagerplaetze?.map((o) => ({ label: o.lagerplatz, value: o })),
        dismiss: true,
      }
    );

    if (result === 'DISMISSED') {
      await this.router.navigate(['/inventur']);
      return;
    }

    this.loading$.next(true);
    try {
      await this.store.dispatch(
        SOFTLINE_FEATURE_INVENTUR,
        InventurStore.actions.loadLagerplatz,
        result.barcode
      );
      this.loading$.next(false);
      await this.router.navigate(['/inventur/artikel-auswahl']);
    } catch (e) {
      this.loading$.next(false);
      showRequestErrors(this.store, e);
    }
  }

  async onSelect(artikel: ArtikelMenge | undefined): Promise<void> {
    if (!artikel) return;
    this.store.commit(SOFTLINE_FEATURE_INVENTUR, InventurStore.mutations.setArtikel, {
      ...artikel,
    });
    await this.router.navigate(['/inventur', 'mengen-auswahl']);
  }
}
